var _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLabelSheets(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_78)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "#FFF3DF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1898 19.8287C29.7714 21.2472 29.7714 23.5477 31.1898 24.9661C32.6083 26.3846 34.9207 26.3846 36.3511 24.9661C37.7695 23.5477 37.7695 21.2472 36.3511 19.8287C34.9207 18.4103 32.6083 18.4103 31.1898 19.8287ZM35.0518 23.6907C34.3366 24.394 33.1804 24.394 32.4771 23.6907C31.762 22.9875 31.762 21.8312 32.4771 21.1161C33.1923 20.4128 34.3485 20.4128 35.0518 21.1161C35.767 21.8312 35.767 22.9755 35.0518 23.6907Z",
    fill: "#957137"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4514 14H28.6628C27.733 14 27.5662 14.4053 26.6722 15.335L15.0624 26.8972C13.6439 28.3275 13.6439 30.628 15.0743 32.0465L24.0975 41.0459C25.516 42.4644 27.8284 42.4644 29.2588 41.0459L40.8686 29.4838C41.6195 28.7447 42.144 28.3633 42.144 27.4455V15.6807C42.1321 14.7509 41.3812 14 40.4514 14ZM27.9595 39.7586C27.2443 40.4618 26.0881 40.4618 25.3849 39.7586L16.3616 30.7592C15.6464 30.0559 15.6464 28.8997 16.3616 28.1845L17.6609 26.8852L29.2349 38.4832L27.9595 39.7586ZM40.4514 26.5873C40.4514 27.0521 40.0223 27.7315 39.5694 28.1845L30.5461 37.1839L18.9601 25.5979L27.9714 16.6104C28.3886 16.1932 29.0442 15.6688 29.5091 15.6688H39.617C40.0819 15.6688 40.4633 16.0502 40.4633 16.5031V26.5873H40.4514Z",
    fill: "#957137"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_78"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabelSheets);
export default __webpack_public_path__ + "static/media/LabelSheets.e577870dd545a8a06ae57fb9ab746e7e.svg";
export { ForwardRef as ReactComponent };